import { useTranslations } from 'next-intl'

export function NoCoursesMessage({ onClearFiltersClick, ...props }) {
  const t = useTranslations('Courses')
  return (
    <div
      {...props}
      className={`flex flex-col items-center justify-center gap-4 rounded-3xl bg-white px-4 py-9 text-center ${props.className}`}
    >
      <h2 className="text-lg font-medium leading-[normal] text-black">
        {t('no_results')}
      </h2>
      <p className="text-text max-w-[185px]">{t('clear_filters_message')}</p>
      <button
        type="button"
        onClick={() => onClearFiltersClick()}
        className="mt-6 rounded-md bg-[--lines] p-4 py-1 text-black hover:bg-black hover:text-white"
      >
        {t('clear_filters_button')}
      </button>
    </div>
  )
}
